import dataService from 'services/dataService';
import { API_CALL_TRANSCRIBE_DOWNLOAD_LINK } from 'services/dataService/resources/callManagement';
import QueryParams from 'utils/queryParams';
import { t } from 'i18next';

import { normalizeTranscript } from './normalize';

import type {
  TranscriptItem,
  GetCallTranscribeProps,
  GetCallTranscribeLinkResponse,
} from './types';

export const getCallTranscribeLinkFn = async (
  props: GetCallTranscribeProps,
): Promise<string | void> => {
  const url = QueryParams.stringifyUrl(API_CALL_TRANSCRIBE_DOWNLOAD_LINK, {
    callId: props.callId,
    callType: props.module,
    patientGuid: props.patientGuid,
  });

  const { error, data } =
    await dataService.getList<GetCallTranscribeLinkResponse>(url);

  if (data && data.url) {
    return data.url;
  }

  if (data && 'message' in data && data.message) {
    throw new Error(data.message);
  }

  if (error) {
    throw new Error(error);
  }
};

export const getCallTranscribeFn = async (
  props: GetCallTranscribeProps,
): Promise<TranscriptItem[]> => {
  const url = await getCallTranscribeLinkFn(props);

  if (!url) {
    throw new Error(t('messages.errorWhileLoadingTranscript'));
  }

  try {
    const response = await fetch(url);
    const data = await response.json();
    const transcripts = await normalizeTranscript(data);

    return transcripts;
  } catch (error) {
    throw new Error(t('messages.errorWhileLoadingTranscript'));
  }
};
